module.exports = __webpack_public_path__ + "static/img/fluo.041632b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fluo.png
// module id = pDm+
// module chunks = 1